import { useQuery } from '@tanstack/react-query';
import type { GetPendingRefillsDetailedParams } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPendingRefillsDetailed } from '../api/getPendingRefillsDetailed.js';
import { rxKeys } from './keys.js';

export function pendingRefillsDetailedQueryDefinition(params?: GetPendingRefillsDetailedParams) {
  return {
    queryKey: rxKeys.pendingRefillsDetailed(params),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchPendingRefillsDetailed(params, signal),
    meta: {
      toast: {
        title: 'Could not load detailed pending refills',
        description: 'Detailed pending refills could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePendingRefillsDetailedQuery(params?: GetPendingRefillsDetailedParams) {
  return useQuery(pendingRefillsDetailedQueryDefinition(params));
}
